import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import React from "react";
import DataTable from "../../../components/data-table";
import customersService from "../../../services/customers.service";
import InfoModalContent from "./info";

const headerCells = [
  {
    field: "phoneNumber",
    title: "شماره تلفن",
    mainField: true,
    renderer: (v) => <span className="en">{v}</span>,
  },
  {
    field: "fullName",
    title: "نام",
  },
  {
    field: "ordersCount",
    title: "سفارشات",
    center: true,
  },
  {
    field: "createDate",
    title: "تاریخ ایجاد",
    date: true,
  },
  {
    field: "nationalCode",
    title: "کد ملی",
  },
  {
    field: "email",
    title: "ایمیل",
  },
];
const defaultKeys = [
  {
    title: "نام",
    field: "fullName",
    active: true,
  },
  {
    field: "phoneNumber",
    title: "شماره تلفن",
    active: true,
  },
  {
    field: "nationalCode",
    title: "کد ملی",
    active: true,
  },
  {
    field: "email",
    title: "ایمیل",
    active: true,
  },
];

export default function CustomersPage() {
  return (
    <div className="p-3">
      <DataTable
        headCells={headerCells}
        searchKeys={defaultKeys}
        backend={customersService.getCustomersUrl}
        title="مشتریان"
        rowActions={[
          {
            modalProps: { maxWidth: "md" },
            icon: <InfoOutlinedIcon />,
            modalContent: (props) => <InfoModalContent {...props} />,
            // hidden: (row) => row.status !== "pending",
          },
        ]}
        orderBy="createDate"
      />
    </div>
  );
}
